import {
    Box,
    Typography,
    Card,
    CardContent,
    CardActions,
    Button,
    IconButton,
} from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import FlexBetween from 'components/FlexBetween';


const ProductCard = ({ product, onAdd, onDecrement, cartQty }) => {
    return (
        <Card
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                position: "relative",
                border: cartQty > 0 ? "2px solid" : "1px solid transparent",
                borderColor: cartQty > 0 ? "primary.main" : "transparent",
            }}
        >
            <CardContent sx={{ flex: 1, pb: 0 }}>
                <Typography 
                    variant="body2" 
                    fontWeight={600} 
                    noWrap 
                    title={product.productName}
                >
                    {product.productName}
                </Typography>
                {product.category && (
                    <Typography variant="caption" color="text.secondary">
                        {product.category}
                    </Typography>
                )}
                <Box mt={1}>
                    <Typography 
                        variant="body1" 
                        color="primary.main" 
                        fontWeight={600}
                    >
                        {(product.price ?? 0).toLocaleString()}
                        <Typography 
                            component="span" 
                            variant="caption" 
                            color="text.secondary" 
                            ml={0.5}
                        >
                            VND
                        </Typography>
                    </Typography>
                    {product.unit && (
                        <Typography variant="caption" color="text.secondary">
                            / {product.unit}
                        </Typography>
                    )}
                </Box>
            </CardContent>

            <CardActions sx={{ pt: 0.5 }}>
                {cartQty === 0 ? (
                    <Button
                        fullWidth
                        variant="outlined"
                        size="small"
                        startIcon={<AddShoppingCartIcon />}
                        onClick={() => onAdd(product)}
                    >
                        Add
                    </Button>
                ) : (
                    <FlexBetween 
                        sx={{
                            width: "100%", 
                            border: "1px solid", 
                            borderColor: "primary.main",
                            borderRadius: 1, 
                            overflow: "hidden",
                        }}
                    >
                        <IconButton
                            size="small"
                            onClick={() => onDecrement(product)}
                            sx={{ 
                                borderRadius: 0, 
                                color: "primary.main",
                                px: 2, 
                                py: 0.75, 
                            }}
                        >
                            <RemoveIcon fontSize="small" />
                        </IconButton>
                        <Typography 
                            variant="body2" 
                            fontWeight={600} 
                            color="primary.main"
                        >
                            {cartQty}
                        </Typography>
                        <IconButton
                            size="small"
                            onClick={() => onAdd(product)}
                            sx={{ 
                                borderRadius: 0, 
                                color: "primary.main", 
                                px: 2, 
                                py: 0.75, 
                            }}
                        >
                            <AddIcon fontSize="small" />
                        </IconButton>
                    </FlexBetween>
                )}
            </CardActions>
        </Card>
    );
};

export default ProductCard;
